package com.karawek.core.settings

import com.karawek.core.platform.PlatformContext
import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.StorageSettings
import com.russhwolf.settings.coroutines.SuspendSettings
import com.russhwolf.settings.coroutines.toSuspendSettings

@OptIn(ExperimentalSettingsApi::class)
internal actual fun createSuspendSettings(
    context: PlatformContext,
    name: String
): SuspendSettings {
    // For web, StorageSettings wraps browser Storage
    val settings = StorageSettings()
    return settings.toSuspendSettings()
}
